/**
 * @file
 * Forms script.
 */

(function formsScript($, Drupal) {
  'use strict';

  /*
   * Add class to 'touched' required form items.
   */
  Drupal.behaviors.touchReqFormItems = {
    attach: function (context) {
      $('.required', context).one('blur keydown', function () {
        $(this).addClass('touched');
      });
    }
  };

  /*
   * User Experience Feedback Form Interactions.
   */
  Drupal.behaviors.pinFeedbackForm = {
    attach: function (context) {
      if ($('.user-experience-form', context).length) {
        var $form = $('.user-experience-form');
        var $first = $('.user-experience-form__first-step');
        var $second = $('.user-experience-form__collection-fields');

        // If a user clicks with a mouse on the faces
        $('label', $first).mouseup(function () {
          var $face = $(this);
          if ($face.attr('for').indexOf('edit-user-feedback-sad') !== -1) {
            $first.hide();
            $second.show();
          }
          else {
            // Response is Happy.
            $('.webform-button--submit', $form).trigger('click');
          }
        });

        // If user presses enter on the inputs
        $('input', $first).keydown(function (e) {
          if (e.which === 13) {
            e.preventDefault();
            var $face = $(this);
            if ($face.attr('value').indexOf('sad') !== -1) {
              $first.hide();
              $second.show();
              $('#edit-additional-response').focus();
            }
            else {
              // Response is Happy.
              $('.webform-button--submit', $form).trigger('click');
            }
          }
        });


      }
    }
  };

}(jQuery, Drupal));
